// Is the signed-in person held on an agency's roster right now?
//
// A held person is hidden from other companies while they are on that agency's
// team, so the app does not offer them a public availability post or browsing
// other work. The server refuses the post too (accounts/views.py, postings);
// this only keeps the doors out of sight. False until /me answers, so nothing
// flickers in for somebody who is not held.
import { useEffect, useState } from "react";
import { fetchWithAuth } from "../utils/fetchWithAuth";

export default function useIsHeld() {
  const [held, setHeld] = useState(false);
  useEffect(() => {
    let live = true;
    fetchWithAuth("/api/accounts/me/")
      .then((me) => { if (live) setHeld(!!me?.is_held); })
      .catch(() => {});
    return () => { live = false; };
  }, []);
  return held;
}
